import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import api from '../../../utils/api';

function SimpleBarChart({ rows }) {
  if (!rows?.length) {
    return <p className="text-sm text-muted-foreground">No trend data yet.</p>;
  }
  const maxPct = Math.max(...rows.map((r) => r.attendance_percentage ?? 0), 1);

  return (
    <div className="space-y-2">
      {rows.slice(-6).map((r) => {
        const pct = r.attendance_percentage ?? 0;
        const w = `${Math.round((pct / maxPct) * 100)}%`;
        return (
          <div key={r.month_label} className="flex items-center gap-2 text-xs sm:text-sm">
            <span className="w-20 shrink-0 text-muted-foreground truncate">{r.month_label}</span>
            <div className="flex-1 h-6 bg-muted rounded overflow-hidden">
              <div
                className="h-full bg-primary/70 rounded transition-all"
                style={{ width: w }}
                title={`${pct}%`}
              />
            </div>
            <span className="w-12 text-right font-medium">{pct}%</span>
          </div>
        );
      })}
    </div>
  );
}

export default function AttendanceAnalyticsPanel({ parentMode, studentId }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (parentMode && !studentId) {
      setRows([]);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const base = parentMode
          ? '/portal/parent/attendance/analytics'
          : '/portal/student/attendance/analytics';
        const params = parentMode ? { student_id: studentId } : undefined;
        const res = await api.get(base, { params });
        if (!cancelled) setRows(res.data?.data?.monthly_rows ?? []);
      } catch {
        if (!cancelled) setRows([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [parentMode, studentId]);

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Attendance trend</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <p className="text-sm text-muted-foreground">Loading analytics…</p>
        ) : (
          <SimpleBarChart rows={rows} />
        )}
      </CardContent>
    </Card>
  );
}
